// Isolated PWA registration. Fully reversible: delete this file and remove its
// import in src/index.js to completely remove the PWA layer.
//
// We deliberately DO NOT register on the CRA dev server (localhost:3000), where
// a service worker fights hot-reload. It registers for the built/served app.

export function registerPWA() {
  if (!("serviceWorker" in navigator)) return;

  const { hostname, port } = window.location;
  const isCraDevServer = hostname === "localhost" && port === "3000";
  if (isCraDevServer) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .catch((err) => console.warn("[pwa] SW registration failed:", err));
  });
}

// Handy escape hatch if you ever want to pull the SW during testing.
export function unregisterPWA() {
  if (!("serviceWorker" in navigator)) return;
  navigator.serviceWorker
    .getRegistrations()
    .then((regs) => regs.forEach((r) => r.unregister()));
}
